import { type TableConfig } from "@/types"
import { type ProjectCustomer } from "@/graphql/types"
import { i18n } from "@/i18n"
import { type MappedProjectCustomer } from "@/store/customer"

const config: TableConfig<ProjectCustomer, MappedProjectCustomer> = {
  columnDefs: [
    {
      key: "n",
      header: i18n.global.t("admin.kunden.felder.id.label"),
    },

    {
      key: "name",
      header: i18n.global.t("admin.kunden.felder.name.label"),
    },
    {
      key: "customerNumber",
      header: i18n.global.t("admin.kunden.felder.kundennummer.label"),
      active: false,
    },
    {
      key: "address.street",
      header: i18n.global.t("admin.kunden.felder.strasse.label"),
      active: false,
    },
    {
      key: "address.zipCode",
      header: i18n.global.t("admin.kunden.felder.plz.label"),
      active: false,
    },
    {
      key: "address.city",
      header: i18n.global.t("admin.kunden.felder.ort.label"),
      active: false,
    },
    {
      key: "address.district",
      header: i18n.global.t("admin.kunden.felder.ortsteil.label"),
      active: false,
    },
    {
      key: "address.country",
      format: (customer) =>
        customer.address?.country && i18n.global.t(`countries_code.${customer.address?.country}`),
      header: i18n.global.t("admin.kunden.felder.land.label"),
      active: false,
    },
  ],
}

export default config
